document.addEventListener('DOMContentLoaded', function () {
  class ProductSpecsAccordion extends HTMLElement {
    constructor() {
      super();

      this.panelElements = [];
      this.toggleElements = [];
      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');

      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.panelElements = [...this.querySelectorAll('[data-specs-panel]')];
      this.toggleElements = [...this.querySelectorAll('[data-specs-toggle]')];

      this.toggleElements.forEach((toggleElement) => {
        toggleElement.addEventListener('click', this.handleToggleClick);
      });
      this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);

      this.syncToBreakpoint();
    }

    disconnectedCallback() {
      this.toggleElements.forEach((toggleElement) =>
        toggleElement.removeEventListener('click', this.handleToggleClick),
      );
      this.mobileMediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }

    get isMobile() {
      return this.mobileMediaQuery.matches;
    }

    syncToBreakpoint() {
      this.panelElements.forEach((panelElement) => {
        const toggleElement = panelElement.querySelector('[data-specs-toggle]');

        if (this.isMobile) {
          this.closePanel(panelElement, toggleElement);
        } else {
          this.openPanel(panelElement, toggleElement);
        }
      });
    }

    handleBreakpointChange() {
      this.syncToBreakpoint();
    }

    handleToggleClick(clickEvent) {
      if (!this.isMobile) return;

      const toggleElement = clickEvent.currentTarget;
      const panelElement = toggleElement.closest('[data-specs-panel]');
      const isOpen = panelElement.classList.contains('product-specs__panel--open');

      if (isOpen) {
        this.closePanel(panelElement, toggleElement);
      } else {
        this.openPanel(panelElement, toggleElement);
      }
    }

    openPanel(panelElement, toggleElement) {
      panelElement.classList.add('product-specs__panel--open');
      toggleElement.setAttribute('aria-expanded', 'true');
    }

    closePanel(panelElement, toggleElement) {
      panelElement.classList.remove('product-specs__panel--open');
      toggleElement.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('product-specs-accordion')) {
    customElements.define('product-specs-accordion', ProductSpecsAccordion);
  }
});
